import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWoodenhamsterWhiteLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 200 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	x: "0px",
	y: "0px",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M38.0085 27.0077C30.5338 27.0077 24.457 20.9519 24.457 13.5039C24.457 11.114 25.0846 8.79376 26.2761 6.7442C26.2046 6.41936 26.1649 6.08679 26.1649 5.74649C26.1649 3.12461 28.3573 0.989974 31.0501 0.989974C31.5188 0.989974 31.9874 1.05958 32.4402 1.19106C34.1798 0.409911 36.0862 0 38.0085 0C39.9309 0 41.7896 0.402177 43.5054 1.16013C43.9185 1.05185 44.3554 0.989974 44.7922 0.989974C47.4851 0.989974 49.6775 3.12461 49.6775 5.74649C49.6775 6.00945 49.6536 6.27242 49.6139 6.52764C50.8928 8.63134 51.5601 11.0212 51.5601 13.5039C51.5601 20.9519 45.4833 27.0077 38.0085 27.0077ZM31.0501 4.3234C30.2399 4.3234 29.5806 4.96534 29.5806 5.75423C29.5806 5.94758 29.6203 6.14093 29.6997 6.31882L30.0572 7.13091L29.5647 7.87339C28.4526 9.54397 27.8727 11.493 27.8727 13.5039C27.8727 19.1111 32.4164 23.6743 38.0085 23.6743C43.6007 23.6743 48.1444 19.1111 48.1444 13.5039C48.1444 11.4311 47.5248 9.43569 46.3571 7.73417L45.8726 7.03036L46.1744 6.23374C46.23 6.07906 46.2618 5.90891 46.2618 5.74649C46.2618 4.95761 45.6025 4.31567 44.7922 4.31567C44.5698 4.31567 44.3554 4.36207 44.1568 4.45488L43.3783 4.82612L42.6157 4.43168C41.1859 3.69693 39.6369 3.32569 38.0085 3.32569C36.3801 3.32569 34.7835 3.7124 33.3299 4.47035L32.5276 4.888L31.7253 4.47809C31.5108 4.36981 31.2884 4.31567 31.0501 4.31567V4.3234Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.9607 23.3882C49.7467 23.3882 52.8158 20.3999 52.8158 16.7137C52.8158 13.0274 49.7467 10.0391 45.9607 10.0391C42.1746 10.0391 39.1055 13.0274 39.1055 16.7137C39.1055 20.3999 42.1746 23.3882 45.9607 23.3882Z",
			fill: "#E00303"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.9615 25.043C41.2431 25.043 37.3984 21.3074 37.3984 16.7056C37.3984 12.1038 41.2351 8.36816 45.9615 8.36816C50.6878 8.36816 54.5245 12.1038 54.5245 16.7056C54.5245 21.3074 50.6878 25.043 45.9615 25.043ZM45.9615 11.7016C43.1257 11.7016 40.8221 13.9445 40.8221 16.7056C40.8221 19.4667 43.1257 21.7096 45.9615 21.7096C48.7973 21.7096 51.1009 19.4667 51.1009 16.7056C51.1009 13.9445 48.7973 11.7016 45.9615 11.7016Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0583 23.3882C33.8443 23.3882 36.9135 20.3999 36.9135 16.7137C36.9135 13.0274 33.8443 10.0391 30.0583 10.0391C26.2723 10.0391 23.2031 13.0274 23.2031 16.7137C23.2031 20.3999 26.2723 23.3882 30.0583 23.3882Z",
			fill: "#E00303"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0572 25.043C25.3388 25.043 21.4941 21.3074 21.4941 16.7056C21.4941 12.1038 25.3308 8.36816 30.0572 8.36816C34.7835 8.36816 38.6202 12.1038 38.6202 16.7056C38.6202 21.3074 34.7835 25.043 30.0572 25.043ZM30.0572 11.7016C27.2214 11.7016 24.9178 13.9445 24.9178 16.7056C24.9178 19.4667 27.2214 21.7096 30.0572 21.7096C32.893 21.7096 35.1966 19.4667 35.1966 16.7056C35.1966 13.9445 32.893 11.7016 30.0572 11.7016Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 9.45898H3.79697L6.33092 18.4693L8.99198 9.45898H12.4474L15.2435 18.593L17.8251 9.45898H21.4314L16.9354 23.9915H13.48L10.668 14.8188L7.95933 23.9915H4.50393L0 9.45898Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.5566 9.45898H60.7834C65.621 9.45898 68.7745 12.7151 68.7745 16.7214C68.7745 20.7277 65.621 23.9838 60.7834 23.9838H55.5566V9.45898ZM64.9299 16.7214C64.9299 14.5635 63.5001 12.8156 60.7755 12.8156H59.3933V20.6194H60.7755C63.508 20.6194 64.9299 18.8792 64.9299 16.7136V16.7214Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.3242 9.45898H81.1114V12.8233H74.1609V15.0431H80.5157V18.4074H74.1609V20.6271H81.1988V23.9915H70.3242V9.45898Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.5531 15.3756V23.9915H83.0977V9.45898H86.5531L93.2494 18.0749V9.45898H96.7048V23.9915H93.2494L86.5531 15.3756Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.809 18.3997H102.884V23.9838H99.0469V9.45898H102.884V15.0431H108.809V9.45898H112.646V23.9915H108.809V18.4074V18.3997Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.294 9.45898H122.749L128.508 23.9915H124.394L123.52 21.563H118.126L117.253 23.9915H113.543L119.302 9.45898H119.294ZM122.36 18.3997L120.827 14.1227L119.27 18.3997H122.36Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.399 9.45898H134.768L137.477 16.6595L140.162 9.45898H145.722V23.9915H141.886V14.463L139.09 21.563H135.634L132.838 14.463V23.9915H129.383V9.45898H129.399Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.238 19.3583H151.075C151.075 20.2323 152.012 21.083 153.76 21.083C155.015 21.083 156.151 20.6499 156.151 19.8765C156.151 19.0489 154.848 18.6699 153.251 18.2368C150.757 17.5485 147.58 16.3265 147.58 13.5267C147.58 10.1856 151.186 9.12598 153.569 9.12598C156.937 9.12598 159.646 11.2219 159.646 13.8206H155.809C155.809 13.1787 155.15 12.3666 153.418 12.3666C152.394 12.3666 151.417 12.6605 151.417 13.3411C151.417 14.13 152.695 14.4858 154.276 14.9189C156.77 15.6072 159.988 16.8292 159.988 19.6754C159.988 23.0398 156.381 24.3236 153.657 24.3236C150.074 24.3236 147.238 22.1039 147.238 19.366V19.3583Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.938 12.8233H160.395V9.45898H173.311V12.8233H168.767V23.9915H164.93V12.8233H164.938Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M174.318 9.45898H185.106V12.8233H178.155V15.0431H184.51V18.4074H178.155V20.6271H185.193V23.9915H174.318V9.45898Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M187.084 9.45898H194.44C197.315 9.45898 199.666 11.7406 199.666 14.5481C199.666 16.4352 198.602 18.0981 197.005 18.972L200.008 23.9915H195.766L193.169 19.6294H190.929V23.9915H187.092V9.45898H187.084ZM194.44 16.2651C195.21 16.2651 195.822 15.4994 195.822 14.5403C195.822 13.5813 195.202 12.8156 194.44 12.8156H190.921V16.2573H194.44V16.2651Z",
			fill: "white"
		})
	]
});
export default SvgWoodenhamsterWhiteLogo;
